import React from 'react';
import { styled } from '@mui/material/styles';
import {Box, CircularProgress} from '@mui/material';
const PREFIX = 'LoadingPage';

const classes = {
    container: `${PREFIX}-container`,
    loader: `${PREFIX}-loader`,
};

const StyledBox = styled(Box)(() => ({
    [`&.${classes.container}`]: {
        width: '100%',
        height: '100%',
        position: 'relative',
    },

    [`& .${classes.loader}`]: {
        position: 'absolute',
        top: 'calc(50% - 30px)',
        left: 'calc(50% - 30px)',
    },
}));

const LoadingPage = () => {


    return (
        <StyledBox className={classes.container}>
            <CircularProgress size={60} thickness={4} className={classes.loader} />
        </StyledBox>
    );
};

export default LoadingPage;
